import React, { useContext, useMemo } from 'react';
import { HooksDisplayGrid } from 'ui-components/components/hooks-display-grid';
import { MarkAsShippedContext } from '../context';

import { ColumnContext, ColumnContextProvider } from './columns/context';

import style from './style.module.less';

const getColumnId = (column) => column.id;

const MarkAsShippedGrid = () => {
  const { fulfillmentPlanIds, selectedFulfillmentPlanIds, setSelectedFulfillmentPlanIds } = useContext(MarkAsShippedContext);
  const { columns, onColumnsChange } = useContext(ColumnContext);
  const data = useMemo(() => {
    return fulfillmentPlanIds.map((fulfillmentPlanId) => ({
      id: fulfillmentPlanId,
    }));
  }, [fulfillmentPlanIds]);

  return (
    <div className={style.grid}>
      <HooksDisplayGrid
        columns={columns}
        data={data}
        getColumnId={getColumnId}
        onColumnsChanged={onColumnsChange}
        onSelectedChanged={setSelectedFulfillmentPlanIds}
        selected={selectedFulfillmentPlanIds}
      />
    </div>
  );
};

export default () => (
  <ColumnContextProvider>
    <MarkAsShippedGrid />
  </ColumnContextProvider>
);
